function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-layers_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.159 5.257L10.917.263a1.75 1.75 0 00-1.834 0L.841 5.257A1.745 1.745 0 000 6.756c0 .617.314 1.178.841 1.5l8.243 5.073a1.752 1.752 0 001.833 0l8.242-5.072c.527-.323.842-.884.841-1.501 0-.617-.315-1.178-.841-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.696 9.3l-8.168 5.027c-.95.58-2.129.566-3.054.002L.304 9.3C.114 9.584 0 9.524 0 9.88c0 .617.314 1.178.841 1.5l8.243 5.073a1.751 1.751 0 001.833 0l8.242-5.072c.527-.322.842-.493.841-1.11 0-.356-.115-.687-.304-.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.696 12.426l-8.168 5.026a2.926 2.926 0 01-3.054.001l-8.17-5.027c-.19.283-.304.384-.304.74 0 .617.314 1.179.841 1.5l8.243 5.073a1.752 1.752 0 001.833 0l8.242-5.072c.527-.322.842-.884.841-1.501 0-.356-.115-.457-.304-.74z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-layers_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconLayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconLayers;